import { AxiosError, AxiosResponse } from "axios";
import { IResponse, IServerError } from "@websential/cosmic";

import http from "../../common/http-common";

export const DashboardServices = {
  getAllCounts: async (
    clientId: string,
    taxYear: number | null,
  ): Promise<any | IServerError | IResponse> => {
    if (!taxYear || !clientId) return null;
    try {
      const response: AxiosResponse = await http.get<any>(
        `/v1/dashboard-api/?client_id=${clientId}&tax_year=${taxYear}`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      } else {
        return response.data;
      }
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      return {
        status: false,
        message: axiosError.response
          ? axiosError.response.data
          : "Unknown error",
      };
    }
  },
  getAllCombineYearlyData: async (
    clientId: string,
    taxYear: number | null,
  ): Promise<any | IServerError | IResponse> => {
    if (!taxYear || !clientId) return null;
    try {
      const response: AxiosResponse = await http.get<any>(
        `/v1/adjustment-options/combine-yearly-data/?client_id=${clientId}&tax_year=${taxYear}`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      } else {
        return response.data;
      }
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      return {
        status: false,
        message: axiosError.response
          ? axiosError.response.data
          : "Unknown error",
      };
    }
  },
};
